module.exports = __webpack_public_path__ + "img/Gray-Delete-Btn.7bc8ad86.svg";